export default function IconGantLeaf () {
  return (
    <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1H8" stroke="#D5DCDF"/>
    </svg>
  )
}
